export enum COLOR_TAG_TYPE {
    success = 'success',
    processing = 'processing',
    error = 'error',
    warning = 'warning',
    default = '',
}
